import { render, staticRenderFns } from "./LetterSettings.vue?vue&type=template&id=1834e93a&scoped=true"
import script from "./LetterSettings.vue?vue&type=script&lang=js"
export * from "./LetterSettings.vue?vue&type=script&lang=js"
import style0 from "./LetterSettings.vue?vue&type=style&index=0&id=1834e93a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1834e93a",
  null
  
)

export default component.exports